import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  Paper,
  TableContainer,
  TableRow,
  TableCell,
  Grid,
} from "@material-ui/core";
import Transition from "../../stateless/Transition";
import { customDate } from "../../../_utils/utils";
import { DistributionService } from "../../../services/distribution.service";
import { SellService } from "../../../services/sell.service";
import { GuaranteeService } from "../../../services/guarantee.service";
import { makeStyles } from "@material-ui/styles";
import styles from "../../../styles/global-styles";
import { ProductService } from "../../../services/product.service";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  rightButton: styles.buttonRightHeader,
});

const DetailProductModal = ({
  productId,
  siteId,
  onClose,
  open,
  productSold,
}) => {
  const classes = useStyles();
  const [trackingInfo, settrackingInfo] = useState({});

  useEffect(() => {
    (async () => {
      try {
        let productSell = "";
        let productReceipt = "";

        if (productSold) {
          const { data } = await SellService.getSellByProductId(productId);
          const guaranteeInfo = await GuaranteeService.getGuaranteeByProductId(
            productId
          );
          console.log("guaranteeInfo", guaranteeInfo.data);
          console.log("data sold", data);
          productSell = data.createdAt;
        }

        if (siteId === 1) {
          const { data } = await ProductService.getProductById(productId);
          console.log("data product", data);
          settrackingInfo({
            producyRegistration: data.createdAt,
          });
        } else {
          const { data } = await DistributionService.getDistributionByProductId(
            productId
          );
          const {
            product,
            product: { createdAt, factureCreated },
            status_distribution: { status },
          } = data;

          /** get date for factureCreated */
          if (factureCreated) {
            productReceipt = product.updatedAt;
          } else console.log("facture not created Yet");

          settrackingInfo({
            producyRegistration: createdAt,
            distributionCreated: data.createdAt,
            distributionLastUpdated: data.updatedAt,
            lastStatus: status,
            productSold: productSell,
            productReceipt,
          });
        }
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, [productId]);

  const handleClose = () => onClose("detail");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Tracking de producto
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableBody>
              {trackingInfo.producyRegistration?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b>Fecha de alta </b>
                  </TableCell>
                  <TableCell style={{ paddingRight: 45 }}>
                    {customDate(trackingInfo.producyRegistration)}
                  </TableCell>
                </TableRow>
              )}

              {trackingInfo.distributionCreated?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b> Fecha de salida de almacén </b>
                  </TableCell>
                  <TableCell style={{ paddingRight: 45 }}>
                    {customDate(trackingInfo.distributionCreated)}
                  </TableCell>
                </TableRow>
              )}

              {trackingInfo.distributionLastUpdated?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b>Fecha de llegada a sucursal </b>
                  </TableCell>
                  <TableCell style={{ marginRight: 15 }}>
                    {customDate(trackingInfo.distributionLastUpdated)}
                  </TableCell>
                </TableRow>
              )}

              {trackingInfo.lastStatus?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b> Último estatus de distribución:</b>
                  </TableCell>
                  <TableCell style={{ marginRight: 15 }}>
                    {trackingInfo.lastStatus}
                  </TableCell>
                </TableRow>
              )}

              {trackingInfo.productSold?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b> Fecha producto vendido: </b>
                  </TableCell>
                  <TableCell style={{ marginRight: 15 }}>
                    {customDate(trackingInfo.productSold)}
                  </TableCell>
                </TableRow>
              )}

              {trackingInfo.productReceipt?.length > 0 && (
                <TableRow>
                  <TableCell scope="row">
                    <b> Fecha factura generada: </b>
                  </TableCell>
                  <TableCell style={{ marginRight: 15 }}>
                    {customDate(trackingInfo.productReceipt)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          style={{ marginTop: 40 }}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <Button
              className={classes.rightButton}
              type="submit"
              style={{ margin: "15px 0", width: 120 }}
              onClick={() => handleClose()}
            >
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DetailProductModal;
